import { render, staticRenderFns } from "./QMessageComponent.vue?vue&type=template&id=910fd9a8"
import script from "./QMessageComponent.vue?vue&type=script&lang=js"
export * from "./QMessageComponent.vue?vue&type=script&lang=js"
import style0 from "./QMessageComponent.vue?vue&type=style&index=0&id=910fd9a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports